<template>
    <div class="player">
        <video-player v-show="count" class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions"
                    @play="onPlayerPlay($event)"
                    @pause="onPlayerPause($event)"
        >
        </video-player>
        <img v-show="!count" :src="imgSrc" alt="">
        <div class="mask" v-show="!count">
            <div class="sellinfo" v-show="charge === 1">
                <p>付费课程，需购买才能播放！</p>
                <h1>您可通过显示会员价购买！</h1>
                <h2 @click="toBuy()">会员购买</h2>
            </div>
            <div class="chargeinfo" v-show="charge === 0">
                <p>该视频全部免费</p>
                <p>快去学习吧！</p>
            </div>
            <div class="chargeinfo" v-show="charge === 2">
                <p>您已购买全部视频</p>
                <p>快去学习吧！</p>
            </div>
        </div>

    </div>
</template>
<script>
import { videoPlayer } from "vue-video-player";
export default {
  name: "videoplayer",
  created() {
    this.$store.commit("videoPathsChange", false);
  },
  data() {
    return {
      playerOptions: {
        height: "450px",
        preload: "auto", //建议浏览器在video加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为，立即开始加载视频
        autoplay: false, //如果true浏览器准备好时开始回放
        muted: false, //默认情况下将会消除任何音频
        language: "zh-CN",
        loop: false, //导致视频一结束就重新开始
        //playbackRates:[0.7,1.0,1.5,2.0],//播放速度
        fluid: true, //当true时,Video.jsplayer将拥有流体大小。就是他将按照比例缩放以适应其容器
        notSupportedMessage: "收费视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息
        sources: [
          {
            type: "video/mp4",
            src: 'http://file.wm319.com/public/video/c9ba4748426e4cf1a3b4910465612bf6.mp4'
            // src: 'http://file.wm319.com/public/video/c9ba4748426e4cf1a3b4910465612bf6.mp4'
          }
        ],
        poster: "", //封面地址
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      }
    };
  },
  components: {
    videoPlayer
  },
  methods: {
    onPlayerPlay(player) {
      //alert("play");
    },
    onPlayerPause(player) {
      //alert("pause");
    },
    videoPath() {
      let myPlayer = this.$refs.videoPlayer.player;
      //根据userType的不同展示不同的视频地址
    },
    toBuy() {
      this.$emit("tobuy");
    }
  },
  computed: {
    player() {
      return this.$ref.videoPlayer.player;
    },
    count() {
      return this.$store.state.videoPaths;
    },
    computedVideoPath() {
      return this.$store.state.videoPath;
    }
  },
  mounted() {
    // console.log('初始化');
    this.$store.commit("increment", this.$refs.videoPlayer.player);
  },
  // props: ["imgSrc","charge"]
    props: {
        imgSrc:String,
        charge:[String, Number]
    }
};
</script>
<style lang="scss" scoped>
.player {
  height: 424px;
  overflow: hidden;
  img {
    width: 100%;
    height: auto;
  }
}
.player /deep/ .video-player {
  //display: none;
}
.player /deep/ .video-js .vjs-big-play-button {
  /*
				播放按钮换成圆形
			 */
  height: 100px !important;
  width: 100px;
  line-height: 100px !important;
  border-radius: 50px;
  margin-top: -50px !important;
  background: rgba(0, 0, 0, 0.5);
  .vjs-icon-placeholder {
    font-size: 60px;
  }
}
.player /deep/ .video-js .vjs-control-bar {
  font-size: 24px;
}
.player /deep/ .video-js .vjs-mute-control {
  padding-left: 1em !important;
  padding-right: 1em !important;
}
.video {
  line-height: 1;
}
.video /deep/ .player {
  line-height: 1;
}
.container /deep/ .player {
  width: 100%;
  height: auto;
}
.mask {
  width: 100%;
  height: 424px;
  background: #000;
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  opacity: 0.8;
}
.sellinfo{
  height: 200px;
  position: absolute;
  top: 100px;
  left: 187px;
  p {
    font-size: 30px;
    color: #fff;
  }
  h1 {
    font-size: 26px;
    color: #fff;
    padding-left: 35px;
    padding-top: 16px;
    font-weight: normal;
  }
  h2 {
    font-size: 26px;
    color: #fff;
    width: 180px;
    height: 56px;
    background: #ff8005;
    border-radius: 50px;
    line-height: 56px;
    text-align: center;
    font-weight: normal;
    margin-top: 50px;
    margin-left: 100px;
  }
}
.chargeinfo{
    position: absolute;
    width: 300px;
    height: 100px;
    top: 50%;
    left: 50%;
    margin: -50px 0 0 -150px;
    text-align: center;
    color: #fff;
    font-size: 34px;
}
.player {
  width: 100%;
  position: relative;
}
</style>
